const DesignChooserConstants = {
  TAB_CURRENT_SITE: "tabCurrentSite",
  TAB_USER_SITES: "tabUserSites",
  TAB_USER_LIBRARY: "tabUserLibrary",
  TAB_PLATFORM_LIBRARY: "tabPlatformLibrary",
};

export default DesignChooserConstants;
